import { render, staticRenderFns } from "./bookingWorkspace.vue?vue&type=template&id=1386be06&"
import script from "./bookingWorkspace.vue?vue&type=script&lang=js&"
export * from "./bookingWorkspace.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1386be06')) {
      api.createRecord('1386be06', component.options)
    } else {
      api.reload('1386be06', component.options)
    }
    module.hot.accept("./bookingWorkspace.vue?vue&type=template&id=1386be06&", function () {
      api.rerender('1386be06', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Sales/components/remoteBooking/bookingWorkspace.vue"
export default component.exports